import { useMutation } from "@tanstack/react-query";
import { updateComo } from "../../api/bComoApi";

export const useUpdateComo = () => {
  return useMutation({
    mutationKey: ["update-como"],
    mutationFn: (data) => updateComo(data),
    onError: (error) => {
      console.error("Como update error details:", error.response || error);
    },
  });
};
